import React from 'react';
import { NextPage } from 'next';
import Head from 'next/head';
import { IImage, IStory } from '@b2b-frontend/types';
import Image from '@b2b-frontend/components/Image';
import renderContentBlock from '@b2b-frontend/components/renderContentBlock';
import Heading from 'components/Heading';
import MaxWidthContainer from 'components/MaxWidthContainer';
import FeatureList from 'components/FeatureList';
import Breadcrumbs from 'components/Breadcrumbs';

export interface ILearnBrandStoryProps {
	logo: IImage;
	brand: string;
	brand_slug: string;
	story: IStory;
}

const LearnBrandStory: NextPage<ILearnBrandStoryProps> = ({ logo, story }) => {
	return (
		<div>
			<Head>
				<title>
					Welcome to {process.env.appTitle} | L&rsquo;Or&eacute;al Online Orders
				</title>
			</Head>
			<div className="bg-black">
				<MaxWidthContainer className="py-6 flex items-center justify-between">
					<Breadcrumbs dark />
				</MaxWidthContainer>
			</div>
			<div className="capitalize w-full h-[500px] bg-pattern bg-repeat bg-large flex justify-center items-start text-lg">
				<Heading className="py-20">
					<Image image={logo} width={230} height={61} />
				</Heading>
			</div>
			<div className="relative w-full bg-white max-w-[1640px] transform -translate-y-72 -mb-72 mx-auto pt-8 md:pt-24">
				<MaxWidthContainer>
					<div className="mb-10">{story.content.map(renderContentBlock)}</div>
				</MaxWidthContainer>
			</div>
			<FeatureList />
		</div>
	);
};

export default LearnBrandStory;
